import httpClient from "../../api/httpClient";
import Contrato from "../classes/Contrato";
import Forecast from "../classes/Forecast";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Forecast/" },
  { method: "GET", rota: "Forecast/{id}" },
  { method: "POST", rota: "Forecast/Adicionar" },
  { method: "POST", rota: "Forecast/DetalharAno" },
  { method: "PUT", rota: "Forecast/Atualizar" },
  { method: "DELETE", rota: "Forecast/Apagar" },
  { method: "POST", rota: "Forecast/Diarizado/Montar" },
  { method: "POST", rota: "Forecast/Integrar" }

];

const cacheKey: string = "ForecastCache";
const cacheKeySelC: string = "ForecastSelecionado";

const apiServico: String = "PLANEJAMENTO"

interface integracao {
  idParceiro: Number;
  data: string;
  sku: string;
  centro: string;
  quantidade: number;
}

class ForecastDatasetPortal extends httpClient {
  constructor(apiServicoAlt: string = "") {
    if (apiServicoAlt === "")
      super(String(apiServico));
    else
      super(String(apiServicoAlt));
  }
  Adicionar(value: Forecast) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[2].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  DetalharAno(value: Contrato) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[2].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  DetalharMes(value: Forecast) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[6].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Atualizar(value: Forecast) {
    let ok: boolean = false;
    let error: any = undefined;
    super.put(calls[4].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Apagar(value: Forecast) {
    let ok: boolean = false;
    let error: any = undefined;
    super.delete(calls[5].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  async ListarAtivos(codigoFornecedorSap: number, numeroContrato: string): Promise<Forecast[]> {
    return await super.Get(calls[0].rota + codigoFornecedorSap + '/Contrato/' + numeroContrato)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async Integra(value: Forecast, origem: String) {
    let dado: integracao = { idParceiro: value.codigoFornecedorSap, data: value.anoMesRef.toString(), sku: value.idSku.toString(), centro: value.centro.toString(), quantidade: value.quantidadeProposta };
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[7].rota + "/" + origem, dado).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): Forecast[] {
    let result: Forecast[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: Forecast[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

}
export default ForecastDatasetPortal;

